import { DpContainer, DpContainerProps } from '@/components/blocks/DpContainer';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { CardLink } from '@/components/content/DpHelpCenter/parts/CardLink';
import {
	HowToBuySvg,
	MyAccountSvg,
	MyOrderSvg,
	PaymentMethodsSvg,
	ReturnsSvg,
	ShippingDeliveriesSvg,
} from '@/components/content/DpHelpCenter/parts/Icons';
import {
	HelpCenterDescriptionSx,
	HelpCenterGridSx,
	HelpCenterTitleSx,
} from '@/components/content/DpHelpCenter/styles/main';
import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';

export const HelpCenter: React.FC<DpContainerProps> = (props) => {
	const [selectedId, setSelectedId] = useState('DPV2HelpCenterMyOrder');

	const handleClick = (id: string) => {
		setSelectedId(id);
	};

	const links = [
		{
			id: 'DPV2HelpCenterMyOrder',
			name: 'MI PEDIDO',
			icon: <MyOrderSvg />,
		},
		{
			id: 'DPV2HelpCenterRefunds',
			name: 'DEVOLUCIONES',
			icon: <ReturnsSvg />,
		},
		{
			id: 'DPV2HelpCenterDeliveryShipping',
			name: 'ENVÍO Y ENTREGAS',
			icon: <ShippingDeliveriesSvg />,
		},
		{
			id: 'DPV2HelpCenterPaymentMethods',
			name: 'FORMAS DE PAGO',
			icon: <PaymentMethodsSvg />,
		},
		{
			id: 'DPV2HelpCenterHowToBuy',
			name: 'CÓMO COMPRAR',
			icon: <HowToBuySvg />,
		},
		{
			id: 'DPV2HelpCenterMyAccount',
			name: 'MI CUENTA',
			icon: <MyAccountSvg />,
		},
	];

	return (
		<DpContainer {...props}>
			<Typography component="h1" sx={HelpCenterTitleSx}>
				{'CENTRO DE AYUDA'}
			</Typography>
			<Typography component="h2" sx={HelpCenterDescriptionSx}>
				{'¿Con qué tema te podemos ayudar? Selecciona una categoría de las opciones aquí debajo.'}
			</Typography>
			<Box sx={HelpCenterGridSx}>
				{links.map(({ name, id, icon }) => (
					<CardLink
						key={name}
						name={name}
						isActive={id === selectedId}
						icon={icon}
						onClick={() => handleClick(id)}
					/>
				))}
			</Box>
			<ContentRecommendation
				id={selectedId}
				properties={{
					emsName: selectedId,
				}}
			/>
		</DpContainer>
	);
};
